import { get, patch, post } from 'store/http/httpAction';
import Enums from 'utils/EnumsManager';
import { addData } from 'store/metaData/reports/actions';
import {
  COMMIT_DATA,
  REVERT_SLOTS,
  SET_DASHBOARD_NAME,
  SET_DETAILS,
  RESET_DETAILS,
  ADD_REPORT_TO_ZONE,
  ADD_SLOT_TO_ZONE,
  SWAP_SLOT_WITH_REPORT,
  SWAP_SLOT_WITH_SLOT
} from './actionTypes';

const { DateOnly } = Enums.FieldTypes;

export const setDashboardName = name => ({
  type: SET_DASHBOARD_NAME,
  payload: { name }
});

export const revertSlots = () => ({
  type: REVERT_SLOTS
});

export const commitData = data => ({
  type: COMMIT_DATA,
  payload: { data }
});

export const tryUpdateDashboard = (
  dashboardId,
  dashboardFolderId,
  callback
) => (dispatch, getState) => {
  // TODO: revise
  const { dashboardSettings, metaData } = getState();
  const { details } = dashboardSettings;

  const fieldsMetaData = metaData.fields.data;
  const reportsMetaData = metaData.reports.data;

  const dashboardData = {
    name: details.title,
    slots: details.slots.map(s => {
      const report = reportsMetaData.find(r => r.id === s.reportId);
      const field = fieldsMetaData.find(
        f => f.name === s.groupSettings && report.type === f.objectType
      );

      // update data group by value for date/datetime field
      const formattedData = s.toApi();
      if (
        field &&
        field.type.indexOf(DateOnly) > -1 &&
        report &&
        report.groupsZone[0]
      ) {
        formattedData.setup_properties.group_by = `${
          report.groupsZone[0].field_name
        }__${report.groupsZone[0].type}`;

        // update order setting with concat type string if selected this field
        if (
          formattedData.setup_properties.order_by.field_name ===
          report.groupsZone[0].field_name
        ) {
          formattedData.setup_properties.order_by.field_name = `${
            report.groupsZone[0].field_name
          }__${report.groupsZone[0].type}`;
        }
      }
      return formattedData;
    })
  };

  // Create dashboard in folder
  if (Number(dashboardId) < 0) {
    return post(
      `/admin/dashboard/dashboard_folder/${dashboardFolderId}`,
      dashboardData,
      dispatch
    ).then(data => {
      callback(`/dashboards/${data.data.id}/settings`);
    });
  }

  return patch(`/admin/dashboard/${dashboardId}`, dashboardData, dispatch).then(
    data => {
      if (data && !_.isEmpty(data.data)) {
        dispatch(commitData(data.data));
      }
    }
  );
};

export const setDetails = dashboardDetails => ({
  type: SET_DETAILS,
  payload: { dashboardDetails }
});

export const tryFetchDashboardDetailsById = dashboardId => (dispatch, getState) =>
  get(`/admin/dashboard/${dashboardId}`, {}, dispatch).then(data => {
    dispatch(setDetails(data.data));
    if (_.isArray(data.data.slots)) {
      data.data.slots.forEach(slot => {
        const { reports } = getState().metaData;
        if (slot.report && !_.some(reports.data, { id: slot.report.id })) {
          dispatch(addData(slot.report));
        }
      });
    }
  });

export const resetDetails = () => ({
  type: RESET_DETAILS
});

/*
 * DnD Related
 */
export const addReportToZone = (reportId, x) => ({
  type: ADD_REPORT_TO_ZONE,
  payload: { reportId, x }
});

export const addSlotToZone = (slotId, x) => ({
  type: ADD_SLOT_TO_ZONE,
  payload: { slotId, x }
});

export const swapSlotWithReport = (dragId, dropId, direction) => ({
  type: SWAP_SLOT_WITH_REPORT,
  payload: { dragId, dropId, direction }
});

export const swapSlotWithSlot = (dragId, dropId, direction) => ({
  type: SWAP_SLOT_WITH_SLOT,
  payload: { dragId, dropId, direction }
});



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/flow/actions.js